import {
  callIfFn,
  EntityPlacerBuilder,
  plannerHistoryHelper
} from "src/components/Planner/planner/history";
import {
  PlannerAction
} from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import {getDeviceById} from "src/components/Planner/planner/uDev";
import {uDevDOM} from "src/components/Planner/planner/uDev-dom";
import {
  PUTDevData,
  recalcAllRoomsDynamicProps,
  recalcBaseDevSize,
  redrawRooms,
  saveProportionRelatedProps,
  sendNewSize,
  setDeviceSize,
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {redrawDevice} from "src/components/Planner/planner/deviceDrawing";
import $ from "jquery";
import {_does} from "src/components/Planner/planner/uMath";
import {deepCopy} from "src/components/Planner/controller";
import {redrawMeasurements} from "src/components/Planner/planner/measurement";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";

export class ModifyScaleNoErrorAction extends PlannerAction {
  constructor(fromRatio, fromLO1PX, toRatio, toLO1PX, matSaveState) {
    super();
    this.actionName = ts("p_do_action_ratio_mod", "Modifying ratio line");
    this.fromRatio = deepCopy(fromRatio);
    this.fromLO1PX = fromLO1PX;
    this.toRatio = deepCopy(toRatio);
    this.toLO1PX = toLO1PX;
    this.matSaveState = matSaveState;
  }

  execute(callback) {
    PlannerGlobals.LENGTHOF1PX = this.toLO1PX;
    PlannerGlobals.lastRatioPoints = deepCopy(this.toRatio);
    this.recalcProps();
    this.save(callback);
  }

  undo(callback) {
    PlannerGlobals.LENGTHOF1PX = this.fromLO1PX;
    PlannerGlobals.lastRatioPoints = deepCopy(this.fromRatio);
    this.recalcProps();
    this.save(callback);
  }

  save(callback) {
    const thisVar = this;
    refreshFloorView();
    saveProportionRelatedProps()
    .done(function () {
      PlannerGlobals.wallSegmentation.recalcPreserveSave(thisVar.matSaveState, true);
      new EntityPlacerBuilder()
      .setMatSaveState(PlannerGlobals.wallSegmentation.getSaveDataV2())
      .run().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
    })
    .fail(function () {
      callIfFn(callback, false);
    });
  }

  roomIdChanged(from, to) {
    plannerHistoryHelper.updateMatStateRoomId(from, to, this.matSaveState);
  }

  recalcProps() {
    redrawMeasurements();
    recalcAllRoomsDynamicProps();
    recalcBaseDevSize();
    redrawRooms();
  }
}

export class ModifyScaleErrorAction extends PlannerAction {
  /**
   *
   * @param {number} fromScale
   * @param {number} toScale
   * @param {Segment} fromRatio
   * @param {number} fromLO1PX
   * @param {Segment} toRatio
   * @param {number} toLO1PX
   * @param {Device[]} backupDevs
   * @param {Object.<string, D3Device>} devPlacements
   */
  constructor(fromScale, toScale, fromRatio, fromLO1PX, toRatio, toLO1PX, backupDevs, devPlacements, matSaveState) {
    super();

    if (!_does([50, 100, 150]).contain(fromScale)) {
      console.warn('Received invalid fromScale!');
      this.error = true;
    }

    if (!_does([50, 100, 150]).contain(toScale)) {
      console.warn('Received invalid toScale!');
      this.error = true;
    }

    this.fromScale = fromScale;
    this.toScale = toScale;
    this.fromRatio = deepCopy(fromRatio);
    this.actionName = this.fromScale == this.toScale ? ts("p_do_action_ratio_mod", "Modifying ratio line")
        : ts("p_do_action_scale_mod", "Modifying device size");
    this.fromLO1PX = fromLO1PX;
    this.toRatio = deepCopy(toRatio);
    this.toLO1PX = toLO1PX;
    this.devsPreChange = deepCopy(backupDevs);
    /**
     * @type {Device[]}
     */
    this.devsPostChange = [];
    var thisVar = this;
    var postDevsCopy = deepCopy(devPlacements);
    for (var key in postDevsCopy) {
      postDevsCopy[key].devices.forEach(function (dev) {
        thisVar.devsPostChange.push(dev);
      });
    }
    this.changesMat = this.fromLO1PX != this.toLO1PX;
    this.matSaveState = matSaveState;
  }

  deviceIdChanged(from, to) {
    var thisVar = this;
    this.devsPreChange.concat(this.devsPostChange).forEach(function (dev) {
      if (thisVar.equalAsString(from, dev.deviceId)) {
        dev.deviceId = to;
      }
    });
  }

  execute(callback) {
    PlannerGlobals.DEVICE_SIZE_MOD = this.toScale;
    PlannerGlobals.LENGTHOF1PX = this.toLO1PX;
    PlannerGlobals.lastRatioPoints = deepCopy(this.toRatio);

    this.devsPostChange.forEach(function (dev) {
      var realDev = getDeviceById(dev.deviceId);
      if (realDev) {
        ['x', 'y', 'angle', 'roomId', 'rotate_value'].forEach(function (prop) {
          realDev[prop] = dev[prop];
        });
        redrawDevice(realDev.deviceId);
        var d3grp = uDevDOM.getDeviceD3Group(realDev.deviceId);
        PUTDevData(d3grp);
      }
    });

    this.recalcProps();
    this.save(callback, this.changesMat ? PlannerGlobals.wallSegmentation.getEmptySaveData() : {});
  }

  undo(callback) {
    PlannerGlobals.DEVICE_SIZE_MOD = this.fromScale;
    PlannerGlobals.LENGTHOF1PX = this.fromLO1PX;
    PlannerGlobals.lastRatioPoints = deepCopy(this.fromRatio);

    var backupArr = this.devsPreChange;
    for (var key in backupArr) {
      var backup = backupArr[key];
      var targetDev = getDeviceById(backup.deviceId);
      if (targetDev) {
        for (var j in backup) {
          targetDev[j] = backup[j];
        }
        redrawDevice(backup.deviceId);
        var d3grp = uDevDOM.getDeviceD3Group(backup.deviceId);
        PUTDevData(d3grp);
      }
    }

    this.recalcProps();
    this.save(callback);
  }

  save(callback) {
    const thisVar = this;
    $('[id^="planner-devsize"]').hide();
    $('#planner-devsize-' + PlannerGlobals.DEVICE_SIZE_MODS[PlannerGlobals.DEVICE_SIZE_MOD].btn).show();
    refreshFloorView();
    sendNewSize(function (res) {
      if (res) {
        saveProportionRelatedProps()
        .done(function () {
          PlannerGlobals.wallSegmentation.recalcPreserveSave(thisVar.matSaveState, true);
          new EntityPlacerBuilder()
          .setMatSaveState(PlannerGlobals.wallSegmentation.getSaveDataV2())
          .run().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
        })
        .fail(function () {
          callIfFn(callback, false);
        });
      }
      else {
        callIfFn(callback, false);
      }
    });
  }

  roomIdChanged(from, to) {
    plannerHistoryHelper.updateMatStateRoomId(from, to, this.matSaveState);
  }

  recalcProps() {
    redrawMeasurements();
    recalcAllRoomsDynamicProps();
    recalcBaseDevSize();
    redrawRooms();
  }
}

export class ModifyDevSizeNoErrorAction extends PlannerAction {
  constructor(from, to) {
    super();
    this.actionName = ts("p_do_action_scale_mod", "Modifying device size");
    this.from = from;
    this.to = to;
  }

  execute(callback) {
    setDeviceSize(this.to, function () {
      refreshFloorView();
      callIfFn(callback, true);
    });
  }

  undo(callback) {
    setDeviceSize(this.from, function () {
      refreshFloorView();
      callIfFn(callback, true);
    });
  }
}
